// extracted by mini-css-extract-plugin
export default {"table-width":"Step2_table-width__YiTcl","txt-underline":"Step2_txt-underline__1EDCQ","table-width1":"Step2_table-width1__8RbrL"};